(function(){
  const form = document.getElementById('contactForm');
  const submitBtn = document.getElementById('contactSubmit');
  if (!form) return;

  // Create modal popup for success/failure
  const modal = document.createElement('div');
  modal.id = 'contactModal';
  modal.className = 'fixed inset-0 flex items-center justify-center z-50 hidden';
  modal.innerHTML = `
    <div class="absolute inset-0 bg-black/50" data-close="true"></div>
    <div class="bg-white rounded-2xl p-6 max-w-lg w-full relative z-10">
      <button aria-label="Close" data-close class="absolute top-4 right-4 text-slate-400 hover:text-slate-600">×</button>
      <h3 id="contactModalTitle" class="text-lg font-semibold mb-2">Status</h3>
      <p id="contactModalMessage" class="text-sm text-slate-600 mb-4"></p>
      <div class="text-right">
        <button id="contactModalOk" class="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-full">OK</button>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const showModal = (title, message) => {
    const t = document.getElementById('contactModalTitle');
    const m = document.getElementById('contactModalMessage');
    t.textContent = title;
    m.textContent = message;
    modal.classList.remove('hidden');
  };
  const hideModal = () => modal.classList.add('hidden');

  modal.addEventListener('click', (ev)=>{
    if (ev.target && (ev.target.dataset.close === 'true' || ev.target.dataset.close !== undefined)) hideModal();
  });
  const okBtn = document.getElementById('contactModalOk');
  okBtn && okBtn.addEventListener('click', ()=> hideModal());

  // Validation helpers
  function isValidEmail(email){
    // Simple but practical regex (covers most common addresses)
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function isValidPhone(phone){
    if (!phone) return false;
    // Allow digits, spaces, dashes, parentheses and leading +. Normalize to digits for length check.
    const normalized = phone.replace(/[^\d+]/g, '');
    // Remove plus for length check
    const digits = normalized.replace(/\+/g, '');
    return /^\+?[\d\s\-()\.]{7,25}$/.test(phone) && digits.length >= 7 && digits.length <= 15;
  }

  form.addEventListener('submit', function(e){
    // Prevent normal submit — we'll do AJAX. If Fetch isn't available, let the browser submit.
    if (!window.fetch) return; // fallback to normal POST
    e.preventDefault();

    // Basic required checks
    const name = form.querySelector('[name="name"]');
    const email = form.querySelector('[name="email"]');
    const phone = form.querySelector('[name="phone"]');

    if (name && !name.value.trim()){
      name.focus();
      showModal('Missing information', 'Please enter your name.');
      return;
    }
    if (email && !email.value.trim()){
      email.focus();
      showModal('Missing information', 'Please enter your email.');
      return;
    }

    // Email format validation
    if (email && !isValidEmail(email.value.trim())){
      email.focus();
      showModal('Invalid email', 'Please enter a valid email address.');
      return;
    }

    // Phone required + validation
    if (phone){
      if (!phone.value.trim()){
        phone.focus();
        showModal('Missing phone', 'Please include a phone number so we can contact you.');
        return;
      }
      if (!isValidPhone(phone.value.trim())){
        phone.focus();
        showModal('Invalid phone', 'Please enter a valid phone number (include country code if possible).');
        return;
      }
    }

    // Disable submit
    if (submitBtn){
      submitBtn.disabled = true;
      submitBtn.classList.add('opacity-60', 'cursor-not-allowed');
    }

    const data = new FormData(form);

    fetch(form.action, {
      method: form.method || 'POST',
      body: data,
      headers: {
        'Accept': 'application/json'
      }
    }).then(async response => {
      if (response.ok){
        showModal('Thanks!', 'We received your request. We\'ll contact you shortly.');
        form.reset();
        if (submitBtn){
          submitBtn.disabled = false;
          submitBtn.classList.remove('opacity-60', 'cursor-not-allowed');
        }
      } else {
        const json = await response.json().catch(()=>null);
        const msg = (json && json.error) ? json.error : 'Submission failed. Please try again later.';
        showModal('Submission failed', msg);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('opacity-60', 'cursor-not-allowed');
        }
      }
    }).catch(err => {
      showModal('Network error', 'Network error — please try again.');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('opacity-60', 'cursor-not-allowed');
      }
    });
  });
})();
